export default {
	// ...
	currentFertiger: (state) => (id) => {
		return state.fertiger.filter((f) => f.id === parseInt(id))[0];
	},
	getWeldlineString: (state) => (weldlines) => {
		let text = "";

		if (weldlines.length === 1) {
			text = "1 Schweißnaht";
		} else if (weldlines.length > 1) {
			text = `${weldlines.length} Schweißnähte`;
		}
		const numberOfCorners = weldlines.reduce(
			a,
			(b) => {
				return a + b.corners.length;
			},
			0
		);
		if (numberOfCorners === 1) {
			text += ` | 1 Ecke`;
		} else if (numberOfCorners > 1) {
			text += ` | ${numberOfCorners} Ecken`;
		}
		if (weldlines.some((w) => w.clean)) {
			text += ` | verputzt`;
		} else {
			text += ` | unverputzt`;
		}
		return text;
	},
	getPowdercoatingFinishText: (state) => (value) => {
		switch (value) {
			case 0: {
				return "Matt";
			}
			case 1: {
				return "Glanz";
			}
			default: {
				return "Nicht verfügbar";
			}
		}
	},
	getPowdercoatingStructureText: (state) => (value) => {
		switch (value) {
			case 2: {
				return "Glatt";
			}
			case 0: {
				return "Fein";
			}
			case 1: {
				return "Grob";
			}
			default: {
				return "Nicht verfügbar";
			}
		}
	},
};
